export default __webpack_public_path__ + "static/media/SV.28494c79.pdf";